<template>
  <!-- wd--mb-3 is for cancelling padding-bottom of v-container in layout -->
  <div class="termsContainer wd--mb-3">
    <div class="background--white" />
    <v-tabs v-model="currentPathTab" :grow="isMobile" bg-color="white" color="orange50">
      <v-tab class="termTab" exact :to="tosPagePath"> {{ $t('term_cusomer') }} </v-tab>
      <v-tab class="termTab" exact :to="privacyPagePath"> {{ $t('term_privacy') }} </v-tab>
    </v-tabs>
    <v-window v-model="currentPathTab" continuous="">
      <v-window-item class="termTab__item" :value="tosPagePath">
        <h1 class="wd-my-6">{{ $t('term_cusomer') }}</h1>
        <client-only>
          <div v-html="$t('agree_term_service_content_funbook', { merchant_name: merchantName })" />
        </client-only>
      </v-window-item>
      <v-window-item class="termTab__item" :value="privacyPagePath">
        <h1 class="wd-my-6">{{ $t('term_privacy') }}</h1>
        <client-only>
          <div v-html="$t('agree_term_privacy_content_funbook', { merchant_name: merchantName })" />
        </client-only>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { useFunBookV2 } from '@/composition/useFunbookV2'
import { useVuetify } from '@/composition/useUtil'
import { useFunBookV2Store } from '@/store-pinia/funbookV2'

export default defineComponent({
  setup() {
    const nuxtApp = useNuxtApp()
    const vuetify = useVuetify()
    const route = useRoute()
    const { branchId } = useFunBookV2()
    const { merchantName } = storeToRefs(useFunBookV2Store())

    const isMobile = computed(() => vuetify.display.xs.value)
    const currentPathTab = ref(
      nuxtApp.$localePath({
        name: route.name.split('___')[0],
        params: { branch_id: branchId.value },
        query: route.query,
      })
    )

    const tosPagePath = nuxtApp.$localePath({
      name: 'funbook-branch_id-terms',
      params: { branch_id: branchId.value },
      query: route.query,
    })
    const privacyPagePath = nuxtApp.$localePath({
      name: 'funbook-branch_id-terms-privacy',
      params: { branch_id: branchId.value },
      query: route.query,
    })

    onMounted(() => {
      window.scroll({ top: 0 })
    })

    return {
      currentPathTab,
      tosPagePath,
      privacyPagePath,
      merchantName,
      isMobile,
    }
  },
})
</script>

<style lang="scss" scoped>
.termsContainer {
  padding: 0 0 40px;

  .v-tabs {
    position: sticky;
    /* left for header */
    top: 64px;
    z-index: 1;
  }
  :deep(.v-tabs-bar) {
    height: 64px;
  }

  h1 {
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    margin: 40px 0 24px;
  }

  @include xxs {
    padding: 0 20px 24px;

    :deep(.v-tabs-bar) {
      height: 48px;
    }

    h1 {
      margin: 24px 0;
    }
  }
}

.termTab.v-tab {
  font-size: $baseFontSize;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  &:not(.v-tab--active) {
    /* to override a tag color */
    color: $black50 !important;
  }
}

.termTab__item {
  > div :deep(*) {
    font-size: 15px;
    line-height: 180%;
    margin-bottom: 24px;
  }
  :deep(p:last-child) {
    margin-bottom: 0px;
  }

  @include xxs {
    > div :deep(*) {
      font-size: 13px;
      line-height: 180%;
    }
  }
}
</style>
